import callApi from "helpers/callApi";

export function getRegistrationTrackers() {
  return callApi("/registration_tracker", "GET");
}

export function getRegistrationTracker(trackerId) {
  return callApi(`/registration_tracker/${trackerId}`, "GET");
}

export function getRegistrationTrackerHistory(trackerId) {
  return callApi(`/registration_tracker/${trackerId}/history`, "GET");
}

export function postRegistrationTracker(body) {
  return callApi("/registration_tracker", "POST", body);
}

export function putRegistrationTracker(trackerId, body) {
  return callApi(`/registration_tracker/${trackerId}`, "PUT", body);
}

export function deleteRegistrationTracker(trackerId) {
  return callApi(`/registration_tracker/${trackerId}`, "DELETE");
}

/** POST /registration_tracker/{tracker_id}/status — manager company only. */
export function postRegistrationTrackerStatus(trackerId, status) {
  return callApi(`/registration_tracker/${trackerId}/status`, "POST", {
    status,
  });
}

export function postRegistrationTrackerComment(trackerId, body) {
  return callApi(`/registration_tracker/${trackerId}/comments`, "POST", body);
}

export function putRegistrationTrackerComment(trackerId, commentId, body) {
  return callApi(
    `/registration_tracker/${trackerId}/comments/${commentId}`,
    "PUT",
    body
  );
}

export function deleteRegistrationTrackerComment(trackerId, commentId) {
  return callApi(
    `/registration_tracker/${trackerId}/comments/${commentId}`,
    "DELETE"
  );
}

export function getRegistrationTrackerStates(countryId) {
  return callApi("/registration_tracker/states", "GET", { country_id: countryId });
}

export function getRegistrationTrackerTypes() {
  return callApi("/registration_tracker/types", "GET");
}

export function getRegistrationTrackerReferences() {
  return callApi("/registration_tracker/references", "GET");
}

export function getRegistrationTrackerRegistrators() {
  return getRegistrationTrackerReferences();
}
